// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionText_wrapper__4Uqnt","textarea":"SectionText_textarea__f0gdf"};